export enum PlatformTypeEnum {
  Adviser = 'ADVISER',
  Lender = 'LENDER',
}
